module.exports = __webpack_public_path__ + "images/psp/sizeGuide/10x10.svg";